// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ-module--faq--d_-_F","question":"FAQ-module--question--2jrTV","answer":"FAQ-module--answer--2nj0O","isExpanded":"FAQ-module--isExpanded--2TN2b"};